import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const monitoringFaModule = () => import('./monitoring.module').then((m) => m.MonitoringModule);

export const monitoringFaRoutes: Routes = [
  {
    path: 'monitoring',
    canActivateChild: [RoleGuard],
    loadChildren: monitoringFaModule,
    data: {
      enum: 'MONITORING',
      label: 'Monitoring',
      icon: 'ic_task.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'MONITORING_FA',
          label: 'Monitoring FA',
          path: 'monitoring/monitoring-fa/list',
          children: [],
        },
      ],
    },
  },
];
